'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../../components');
var _formatParkingsInfo = require('../../../utils/formatParkingsInfo');var _formatParkingsInfo2 = _interopRequireDefault(_formatParkingsInfo);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


var ParkingTooltip = function ParkingTooltip() {var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},translate = _ref.translate,locale = _ref.locale,parking = _ref.parking;
  var propertyTranslate = translate('propertyDetails', 'details');var
  aboveground = parking.aboveground,underground = parking.underground;

  return (
    _react2.default.createElement(_components.BottomTooltip, {
        closeOnClickOutside: true,
        className: 'parkingTooltip',
        icon: _react2.default.createElement('span', { className: 'icon icon-about' }),
        showOnHover: true },

      _react2.default.createElement('div', null, (0, _formatParkingsInfo2.default)(aboveground, 'ground', propertyTranslate, locale)),
      _react2.default.createElement('div', null, (0, _formatParkingsInfo2.default)(underground, 'underground', propertyTranslate, locale))));


};

ParkingTooltip.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  parking: _propTypes2.default.object.isRequired,
  translate: _propTypes2.default.func.isRequired };exports.default =


ParkingTooltip;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/ParkingTooltip/ParkingTooltip.js
// module id = 2816
// module chunks = 0